import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const StripeProvider = ({ children }) => {
  const settings = useSelector((state) => state.companySetting.settings);

  const stripePromise = useMemo(() => {
    if (settings && settings.stripe_public_key) {
      return loadStripe(settings.stripe_public_key);
    }
    return null;
  }, [settings && settings.stripe_public_key]);

  if (!stripePromise) {
    return <>{children}</>;
  }

  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
